/* eslint-env jest */
import couponSummaryLine from './couponSummaryLine';

describe('couponSummaryLine', () => {
  it('names the free magnets instead of a -$0.00 discount', () => {
    const line = couponSummaryLine({ couponType: 'FREE_MAGNETS_WITH_FREE_SHIPPING', code: 'ELEMMAGNETS' }, 0);
    expect(line).toEqual({
      text: 'Included with your package:', value: '2 FREE photo magnets', useMinus: false, showAfterSavings: false,
    });
  });
  it('keeps the dollar line for percentage offers', () => {
    const line = couponSummaryLine({ couponType: 'PERCENTAGE_WITH_FREE_SHIPPING', code: 'ELEM20' }, 12.5);
    expect(line).toEqual({
      text: 'Discount with code: ELEM20', value: 12.5, useMinus: true, showAfterSavings: true,
    });
  });
  it('does not minus a non-numeric discount', () => {
    expect(couponSummaryLine({ couponType: 'PERCENTAGE', code: 'X' }, undefined).useMinus).toBe(false);
  });
});

describe('couponSummaryLine — free item of your choice (#5747)', () => {
  it('names the free item from the set instead of a -$0.00 discount', () => {
    const line = couponSummaryLine({
      couponType: 'FREE_ADDON_CHOICE',
      code: 'FREEMAGNET',
      freeAddons: [{ name: 'Weekly Dry Erase Magnet - School' }, { name: 'Weekly Dry Erase Magnet - Groovy' }],
    }, 0);
    expect(line).toEqual({
      text: 'Included with each package: a FREE Weekly Dry Erase Magnet', value: 'FREE', useMinus: false, showAfterSavings: false,
    });
  });

  it('shows the value taken off once a pick is in the cart', () => {
    const line = couponSummaryLine({
      couponType: 'FREE_ADDON_CHOICE', code: 'FREEMAGNET', freeItemLabel: 'dry erase magnet', freeAddons: [{ name: 'x' }],
    }, 29.95);
    expect(line).toEqual({
      text: 'Included with each package: a FREE dry erase magnet', value: 29.95, useMinus: true, showAfterSavings: true,
    });
  });
});
